import QSubmenu from '../menu/src/submenu';

export default QSubmenu;
